var exports = {
  "kL": "container__5P2CCA",
  "jY": "isDraggedOver__AHLXjU",
  "qQ": "quotaBannerWithHeader__feBm9t",
  "I6": "inputWrapper__smol65",
  "$E": "withImageUpload__oOSmSL",
  "xu": "inputWrapperWithToolbar__rI_Bdq",
};

module.exports = exports;
